var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "entity-list-layout",
    {
      staticClass: "admin-sensor-list",
      attrs: {
        title: "SENSOR",
        count: _vm.sensors.length,
        query: _vm.search,
        "search-hint": _vm.$t("search_by_text"),
      },
      on: {
        "update:query": function ($event) {
          _vm.search = $event
        },
      },
      scopedSlots: _vm._u([
        {
          key: "title-area-content",
          fn: function () {
            return [
              _vm.showsManagedBy
                ? _c("managed-by-select", {
                    staticClass: "admin-sensor-list__managed-by-select",
                    attrs: { distributors: _vm.distributors },
                    model: {
                      value: _vm.managedBy,
                      callback: function ($$v) {
                        _vm.managedBy = $$v
                      },
                      expression: "managedBy",
                    },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "p-data-list",
        {
          attrs: {
            pagination: _vm.pagination,
            data: _vm.sensors,
            getItemProps: _vm.genItemProps,
          },
          on: {
            "update:pagination": function ($event) {
              _vm.pagination = $event
            },
          },
        },
        [
          _c("data-field", {
            attrs: { name: "No", headerClass: "column--no" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(_vm._s(props.index + 1))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("data-field", {
            attrs: {
              name: _vm.$t("field.type"),
              value: "type_index",
              headerClass: "column--type",
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("sensor-type-label", { attrs: { sensor: props.item } }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("data-field", {
            attrs: {
              name: _vm.$t("field.identifier"),
              value: "_identifier_sort_key",
              sortable: "",
              headerClass: "column--id",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm.showsIdentifier(props.item)
                      ? _c(
                          "span",
                          { staticClass: "admin-sensor-list__sensor-id" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(props.item.device_id) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("data-field", {
            attrs: {
              name: _vm.$t("field.name"),
              value: "name",
              sortable: "",
              headerClass: "column--name",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c(
                      "router-link",
                      {
                        staticClass: "admin-sensor-list__sensor-name",
                        attrs: {
                          to: {
                            name: "admin-sensor",
                            params: { id: props.item.id },
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(props.item.name) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("data-field", {
            attrs: {
              name: _vm.$t("field.installation_date"),
              value: "installed_on",
              sortable: "",
              headerClass: "column--installed-on",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(_vm._s(props.item.installedOnText))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("data-field", {
            attrs: {
              name: _vm.$t("field.threshold"),
              value: "threshold",
              sortable: "",
              headerClass: "column--threshold",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("div", { style: _vm._f("thresholdStyle")(props.item) }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(props.item.thresholdText) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("data-field", {
            attrs: {
              name: _vm.$t("field.place"),
              value: "place",
              sortable: "",
              headerClass: "column--place",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c(
                      "span",
                      { staticClass: "admin-sensor-list__installation-site" },
                      [_vm._v(_vm._s(props.item.place))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _vm.showsManagedBy
            ? _c("data-field", {
                attrs: {
                  name: _vm.$t("field.managed_by"),
                  value: "managedBySortKey",
                  headerClass: "column--managed-by",
                  sortable: "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          props.item.managedByName
                            ? _c(
                                "span",
                                {
                                  staticClass: "admin-sensor-list__managed-by",
                                  class: {
                                    "text--disabled":
                                      props.item.managedByIsDirect,
                                  },
                                },
                                [_vm._v(_vm._s(props.item.managedByName))]
                              )
                            : _c(
                                "span",
                                {
                                  attrs: { "data-testid": "managed-by-empty" },
                                },
                                [_vm._v("--")]
                              ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2926321857
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("data-field", {
            attrs: {
              name: _vm.$t("field.organization_name"),
              value: "created_by.organization_name",
              headerClass: "column--organization",
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    props.item.created_by.organization_id
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "admin-organization",
                                params: {
                                  id: props.item.created_by.organization_id,
                                },
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  props.item.created_by.organization_name
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _c(
                          "span",
                          { attrs: { "data-testid": "organization-empty" } },
                          [_vm._v("--")]
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("data-field", {
            attrs: {
              name: _vm.$t("field.created_by"),
              value: "created_by.name",
              headerClass: "column--name",
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    props.item.created_by.email
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "admin-account",
                                params: { email: props.item.created_by.email },
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(props.item.created_by.name) +
                                "\n        "
                            ),
                          ]
                        )
                      : _c(
                          "span",
                          { attrs: { "data-testid": "created-by-empty" } },
                          [_vm._v("--")]
                        ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }